"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _generateComponentClassNames = require("./generateComponentClassNames.utils");
function generateComponentClassNames(_ref) {
  var component = _ref.component,
    _ref$componentKeySpli = _ref.componentKeySplit,
    componentKeySplit = _ref$componentKeySpli === void 0 ? true : _ref$componentKeySpli,
    children = _ref.children,
    modifiers = _ref.modifiers,
    supportSelectors = _ref.supportSelectors;
  var allClassNames;
  if (component && Array.isArray(children)) {
    allClassNames = (0, _generateComponentClassNames.handleComponentChildrenClassNames)(component, children, modifiers, generateComponentClassNames);
  }
  if (component && !children) {
    allClassNames = (0, _generateComponentClassNames.handleComponentWithoutChildrenClassNames)(component, componentKeySplit, modifiers);
  }
  allClassNames = (0, _generateComponentClassNames.handleComponentClassName)(allClassNames, component, componentKeySplit);
  if (supportSelectors && Array.isArray(supportSelectors)) {
    allClassNames = (0, _generateComponentClassNames.mergeSupportSelectors)(allClassNames, supportSelectors);
  }
  return allClassNames;
}
var _default = exports["default"] = generateComponentClassNames;